import 'jquery';
import 'bootstrap';
import '@fancyapps/fancybox';

(function($) {
	var SP_THEME = {
		// All pages
		'common': {
			init: function() {
				require('./includes/common');

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			},
		},
		// Blog Archive
		'home': {
			init: function() {
				require('./includes/home');

			},
			finalize: function() {
				// JavaScript to be fired on the blog archive, after the init JS
			},
		},
		'archive': {
			init: function() {
				$('.blog-dropdown select').on('change', function(){
					if(jQuery(this).val().length){
						window.location.href = jQuery(this).val();
					}
				});
			},
			finalize: function() {
				// JavaScript to be fired on the blog archive, after the init JS
			},
		},
		// Single blog
		'blog': {
			init: function() {
				$('.blog-dropdown select').on('change', function(){
					if(jQuery(this).val().length){
						window.location.href = jQuery(this).val();
					}
				});
			},
			finalize: function() {

			},
		},
		'careers':{
			init: function() {
				$('.view-more-careers').on('click', function(){
					return false;
				});
			},
			finalize: function() {

			},
		},
		'reviews': {
			init: function() {
				require('./includes/testimonials');
			},
			finalize: function() {
				$('.rating-input').on('change', function(){
					$('.rating-input').children().find('input').attr('value', $(this).val() );
				});
			},
		},
		
		'single_locations': {
			init: function() {
				require('./includes/single-locations');
			},
			finalize: function() {
		
			},
		},

		'term_videos': {
			init: function() {
				require('./includes/term-videos');
			},
			finalize: function() {
		
			},
		},
	};

	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = SP_THEME;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		},
	};

	$(document).ready(UTIL.loadEvents);
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/main.js